import { memo } from "react";

import { Image } from "@components/Image";
import { Link } from "@components/Link";
import { focusRing } from "@react/utilities";
import { type CollectionContentCard } from "@root/tablescape/state";
import { tw } from "classnames";

type Props = Pick<CollectionContentCard, "ctaUrl" | "image" | "mobileImage">;

const styles = {
  base: tw("h-full", "w-full", "md:h-full", "no-underline", focusRing),
  image: tw("object-cover", "h-full", "w-full", "md:block", "hidden"),
  mobileImage: tw("md:hidden", "max-h-60", "w-full", "object-cover"),
};

export const CollectionImageCardBase = ({
  ctaUrl,
  image,
  mobileImage,
}: Props) => {
  const Tag = ctaUrl ? Link : "div";
  return (
    <Tag
      className={styles.base}
      {...(ctaUrl
        ? { to: ctaUrl, unstyled: true, mtrTarget: "cta" }
        : { to: "" })}
    >
      {image && (
        <Image
          className={styles.image}
          data={image.image}
          height={352}
          width={352}
        />
      )}
      {(mobileImage || image) && (
        <Image
          className={styles.mobileImage}
          data={mobileImage?.image ?? image?.image}
          height={240}
          width={328}
        />
      )}
    </Tag>
  );
};

export const CollectionImageCard = memo(CollectionImageCardBase);
